import {
  getAllDashboardTransaction,
  updateDashboardTransaction,
} from "../../../api/coin";
import BootstrapTable from "./CommanPage";

const DashBoardEntries = () => {
  const USER_FIELD = [
    {
      name: "transactionNumber",
      label: "Transaction Number",
      type: "text",
      placeholder: "Enter your Transaction Number",
      isForm: true,
      isTable: true,
      validation: {
        required: "Transaction Number is required",
        minLength: {
          value: 3,
          message: "Minimum 3 characters",
        },
      },
    },
    {
      name: "title",
      label: "Quantity",
      type: "text",
      placeholder: "Enter your qty",
      isForm: true,
      isTable: true,
      validation: {
        required: "qty is required",
        minLength: {
          value: 3,
          message: "Minimum 3 characters",
        },
      },
    },

    {
      name: "status",
      label: "Status",
      type: "select",
      isForm: true,
      isTable: true,
      options: [
        { value: "confirmed", label: "Confirmed" },
        { value: "unconfirmed", label: "Unconfirmed" },
        { value: "pending", label: "Pending" },
      ],
      validation: {
        required: "User type is required",
      },
    },

    {
      name: "createdAt",
      label: "Created At",
      type: "text",
      isForm: false,
      isTable: true,
      render: (val) => new Date(val).toLocaleString(),
    },
    {
      name: "updatedAt",
      label: "Updated At",
      type: "text",
      isForm: false,
      isTable: true,
      render: (val) => new Date(val).toLocaleString(),
    },
  ];
  return (
    <BootstrapTable
      fields={USER_FIELD}
      title={"Dashboard Entries"}
      getAllRecord={getAllDashboardTransaction}
      updateRecord={updateDashboardTransaction}
    />
  );
};

export default DashBoardEntries;
